import _ from 'lodash';

import createAsyncReducer from '@/store/createAsyncReducer.js';
import initialStateReducer from "~/store/initialStateReducer.js";

const featuresReducer = createAsyncReducer({
    name: 'features',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    extraReducers: (builder) => {
        builder.addCase(initialStateReducer.actions.setInitialState.fulfilled, (state, action) => {
            const features = _.keyBy(action.payload.features, 'identity');
            state.records = { ...state.records, ...features };
        });
    }
});

export default featuresReducer;